export const initialFilter = {
  page: 1,
  per_page: 5,
  total: 0,
  total_pages: 0,
  order: null,
  orderBy: null,
};
